import type { ThemeTokens } from '@/shared/ui/theme/tokens';
import { C } from '@/shared/ui/theme/tokens';
import { Spinner } from './Spinner';

interface GlassLoaderProps {
  T: ThemeTokens;
}

export function GlassLoader({ T }: GlassLoaderProps) {
  return (
    <div
      data-testid="glass-loader"
      aria-busy="true"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `${T.surfaceBg}CC`,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        borderRadius: 10,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
    >
      <Spinner size={28} color={C.primary} />
    </div>
  );
}
